import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header';
import { Button, Card, Col, Container, Form, Image, Modal, Row, Spinner, Tab, Table, Tabs } from 'react-bootstrap';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import makeAnimated from "react-select/animated";
import { useSelector } from 'react-redux';

const AdvertisementMgt = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [addAccess, setAddAccess] = useState([]);
    
    console.log("Access :", access);
    
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("AdvertisementMgt:")
            );
            setAddAccess(filteredAccess);
        } 
    }, [access]);
    
    console.log("Menu Access:", addAccess);

    const accessToken = localStorage.getItem("authToken");
    const [inputData, setInputData] = useState({
        title: "",
        type: "",
        sequenceNo: "",
        product: "",
        isTopImage: "",
        isBottomImage: "",
        link: ""
    });
    const [listLoading, setListLoading] = useState(false);
    const [topImageAdd, setTopImageAdd] = useState([]);
    const [bottomImageAdd, setBottomImageAdd] = useState({});
    const [activeTab, setActiveTab] = useState("CLICKABLE");
    const [clickableAdvertisementData, setClickableAdvertisementData] = useState([]);
    const [nonClickableAdvertisementData, setNonClickableAdvertisementData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const animatedComponents = makeAnimated();
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [productsList, setProductsList] = useState([]);
    const [toDate, setToDate] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [singleAdData, setSingleAdData] = useState("");
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [adId, setAdId] = useState('');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [image, setImage] = useState(null);
    const [isOpenUpdateImageModal, setIsOpenUpdateImageModal] = useState(false);
    const [isImageUpdating, setIsImageUpdating] = useState(false);
    const [isRefreshBtnLoading, setIsRefreshBtnLoading] = useState(false);

    const outletData = outlets?.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`,
    }));

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const getAdvertisementList = async () => {
        setListLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("advertisement", { headers });

            if (response?.data?.status === true) {
                const totalNonClickableAdvertisements=response?.data?.data?.advertisements.nonClickableAdvertisements;
                console.log("Total Non Clickable Add :", totalNonClickableAdvertisements);
                
                const nonClickableAdvertisements=totalNonClickableAdvertisements.filter(ad=>ad.isTopImage===false && ad.isBottomImage===false);
                const topImageAdvertisement=totalNonClickableAdvertisements.filter(ad=>ad.isTopImage===true);
                const bottomImageAdvertisement=totalNonClickableAdvertisements.find(ad=>ad.isBottomImage===true);
                setClickableAdvertisementData(
                    response?.data?.data?.advertisements.clickableAdvertisements
                );
                console.log("Top Images :", topImageAdvertisement);
                
                setNonClickableAdvertisementData(nonClickableAdvertisements);
                setTopImageAdd(topImageAdvertisement);
                setBottomImageAdd(bottomImageAdvertisement);
                
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setListLoading(false);
        }
    };

    const getOutlets = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("outlet", { headers });
    
          if (response?.data?.status === true) {
            
            let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");
            
            setOutlets(filteredOutlets);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const getProductsList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product", { headers });
            if (response?.data?.status === true) {
                setProductsList(response?.data?.data?.products);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleOpenViewModal = (id) => {
        setOpenViewModal(true);
        getSingleAdvertisement(id);
    };

    const getSingleAdvertisement = async (id) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`advertisement?_id=${id}`, { headers });

            if (response?.data?.status === true) {
                setSingleAdData(response?.data?.data?.advertisements);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputData((prev) => ({ ...prev, [name]: value }));
    }

    const handleImageChange = () => {
        const input = document.getElementById("imageInput");
        const file = input.files[0];
    
        if (file) {
          const reader = new FileReader();
    
          // reader.onloadend = () => {
          //   const image = new Image();
          //   image.src = reader.result;
    
          //   image.onload = () => {
          //     const width = image.width;
          //     const height = image.height;
    
          //     const aspectRatio = width / height;
          //     const targetAspectRatio = 16 / 9;
    
          //     if (Math.abs(aspectRatio - targetAspectRatio) < 0.01) {
          //       alert("Image dimensions are valid!");
          //       setImage(file);
          //     } else {
          //       alert(
          //         "Image dimensions are not valid. Please choose an image with a 16:9 aspect ratio."
          //       );
          //       input.value = "";
          //     }
          //   };
          // };
    
          setImage(file);
    
          reader.readAsDataURL(file);
        }
    };

    const handleSelectChange = (selected) => {
        setSelectedExcludedOutlets(selected);
    }

    const addAdvertisement = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        try {
            // Format the dates
            const updatedStartDate = fromDate
                ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000)
                        .toISOString()
                        .split("T")[0]
                : null;
        
            const updatedEndDate = toDate
                ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000)
                        .toISOString()
                        .split("T")[0]
                : null;
    
    
            console.log("updatedStartDate :", updatedStartDate);
            console.log("updatedEndDate :", updatedEndDate);
        
            let selectOutlets = selectedExcludedOutlets.map((val) => val?.value);
            console.log("Selected Outlets :", selectOutlets);
            
            let newInputData = {
                ...inputData,
                excludedOutlets: selectOutlets
            }
    
            const formData = new FormData();
            formData.append("title", newInputData.title);
            formData.append("type", newInputData.type);
            formData.append("sequenceNo", newInputData.sequenceNo);
            if(updatedStartDate !== null){
                formData.append("validityStartDate", updatedStartDate);
            }
            if(updatedEndDate !== null){
                formData.append("validityEndDate", updatedEndDate);
            }
            if (newInputData?.product !== "") {
                formData.append("product", newInputData.product);
            }
            if (newInputData?.isTopImage !== "") {
                formData.append("isTopImage", newInputData.isTopImage);
            }
            if (newInputData?.isBottomImage !== "") {
                formData.append("isBottomImage", newInputData.isBottomImage);
            }
            if (newInputData?.link !== "") {
                formData.append("link", newInputData.link);
            }
            formData.append("adImage", image);
        
            // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
            if (selectOutlets?.length > 0) {
                selectOutlets.forEach((outlet, index) => {
                formData.append(`excludedOutlets[${index}]`, outlet);
                });
            }
        
            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };
        
            const response = await axios.post("advertisement", formData, {
                headers,
            });
        
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                e.target.reset();
                setInputData({
                    title: '',
                    type: '',
                    sequenceNo: '',
                    product: '',
                    link: '',
                    isTopImage: '',
                    isBottomImage: ''
                })
                setFromDate(null);
                setToDate(null);
                getAdvertisementList();
                setOpenAddModal(false);
                setSelectedExcludedOutlets([]);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
        
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
                });
            }
        } finally {
          setIsLoading(false);
        }
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setInputData({
            title: "",
            type: "",
            sequenceNo: "",
            product: "",
            isTopImage: "",
            isBottomImage: "",
            link: ""
        })
    }

    const handleOpenEditModal = (data) => {
        console.log("Edited Data :", data);
        
        setOpenEditModal(true);
        setEditedData({
            _id: data?._id,
            title: data?.title,
            type: data?.type,
            sequenceNo: data?.sequenceNo,
            product: data?.product?._id,
            isTopImage: data?.isTopImage,
            isBottomImage: data?.isBottomImage,
            link: data?.link
        })
        // Convert ISO string to Date object
        setFromDate(data?.validityStartDate ? new Date(data.validityStartDate) : null);
        setToDate(
            data?.validityEndDate
              ? new Date(new Date(data.validityEndDate).setDate(new Date(data.validityEndDate).getDate() - 1))
              : null
        );
        
        let selectedExOutlet = data?.excludedOutlets;
        let mappedSelectedExOutlet = selectedExOutlet?.map((m) =>
        ({
            value: m?._id,
            label: m?.name
        }))
        setSelectedExcludedOutlets(mappedSelectedExOutlet);
    };

    const handleEditSelectChange = (selected) => {
        setSelectedExcludedOutlets(selected);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prev) => ({ ...prev, [name]: value }))
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };
    
    const handleToDateChange = (date) => {        
        setToDate(date);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        try {
            // Check if only one of the dates is selected
            if ((fromDate && !toDate) || (!fromDate && toDate)) {
                toast.error("Please select both start date and end date", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setIsLoading(false);
                return;
            }
            // Format the dates
            const updatedStartDate = fromDate
                ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000)
                        .toISOString()
                        .split("T")[0]
                : null;

            const updatedEndDate = toDate
                ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000)
                        .toISOString()
                        .split("T")[0]
                : null;

            let selectedExOutlets = selectedExcludedOutlets?.map((ex) => ex?.value);
            let newEditedData = {
                ...editedData,
                excludedOutlets: selectedExOutlets
            }

            const formData = new FormData();
            formData.append("_id", newEditedData?._id)
            formData.append("title", newEditedData.title);
            formData.append("type", newEditedData.type);
            formData.append("sequenceNo", newEditedData.sequenceNo);
            formData.append("validityStartDate", updatedStartDate);
            formData.append("validityEndDate", updatedEndDate);
            if (newEditedData?.product !== "" && newEditedData?.product !== undefined && newEditedData?.product !== null) {                
                formData.append("product", newEditedData?.product);
            }
            if (newEditedData?.isTopImage !== ""){
                formData.append("isTopImage", newEditedData?.isTopImage);
            }
            if (newEditedData?.link !== ""){
                formData.append("link", newEditedData?.link);
            }
            if (newEditedData?.isBottomImage !== ""){
                formData.append("isBottomImage", newEditedData?.isBottomImage);
            }

            // Check if excluded outlets are empty
            if (selectedExOutlets?.length === 0 || selectedExOutlets === undefined) {
                formData.append("excludedOutlets", null);
            } else {
                selectedExOutlets.forEach((outlet, index) => {
                formData.append(`excludedOutlets[${index}]`, outlet);
                });
            }

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.put("advertisement", formData, {
                headers,
            });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setOpenEditModal(false);
                getAdvertisementList();
                
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 404 ) {
                    errorMessage = error?.response?.data?.data?.message;
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleOpenDeleteModal = (id) => {
        setOpenDeleteModal(true);
        setAdId(id);
    };

    const deleteAdvertisement = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: adId,
            };
            const response = await axios.delete(`advertisement`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAdvertisementList();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const openUpdateImageModal = (data) => {
        setEditedData((prev) => ({
            ...prev,
            _id: data?._id
        }))
        setIsOpenUpdateImageModal(true)
    }

    const handleEditImageChange = (e) => {
        const input = document.getElementById("imageInput");
        const file = input.files[0];

        if (file) {
            const reader = new FileReader();

            // <--------------- This is Validation For Updating Image --------------> 
            // reader.onloadend = () => {
            //     const image = new Image();
            //     image.src = reader.result;

            //     image.onload = () => {
            //         const width = image.width;
            //         const height = image.height;

            //         const aspectRatio = width / height;
            //         const targetAspectRatio = 16 / 9;

            //         if (Math.abs(aspectRatio - targetAspectRatio) < 0.01) {
            //             alert("Image dimensions are valid!");
            //             setImage(file);
            //         } else {
            //             alert(
            //                 "Image dimensions are not valid. Please choose an image with a 16:9 aspect ratio."
            //             );
            //             input.value = "";
            //         }
            //     };
            // };

            setImage(file);

            reader.readAsDataURL(file);
        }
    };

    const handleEditImage = async (e) => {
        // e.preventDefault()
        console.log("HEloo");
        
        setIsImageUpdating(true);

        try {
            const formData = new FormData();
            formData.append("_id", editedData?._id)
            formData.append("adImage", image);

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.put("advertisement", formData, {
                headers,
            });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                e.target.reset()
                setIsOpenUpdateImageModal(false)
                getAdvertisementList()
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsImageUpdating(false)
        }
    };

    const handleRefresh = async() => {
        setIsRefreshBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get('advertisement/clear-advertisement-cache', { headers });
            
            if (response?.data?.status === true) {
                toast.success(response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 404 ) {
                    errorMessage = error?.response?.data?.data?.message;
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsRefreshBtnLoading(false);
        }
    };

    useEffect(() => {
        getAdvertisementList();
        getOutlets();
        getProductsList();
    }, [])

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">ADVERTISEMENT MANAGEMENT</h5>
                        </Col>
                    </Row>

                    <Row className='justify-content-between' style={{ backgroundColor: "whitesmoke" }}>
                        <Col lg="3" className="d-flex justify-content-end flex-column  mt-4">
                            <Button
                              variant="success"
                              className="fw-semibold"
                              onClick={handleRefresh}
                            >
                                {isRefreshBtnLoading ? <Spinner size='sm' /> : (
                                    <>
                                        <i className="ri-refresh-line" style={{ marginRight: "5px" }}></i>
                                        Clear or Refresh Cache
                                    </>
                                ) }
                                
                            </Button>
                        </Col>
                        {(addAccess?.includes("AdvertisementMgt:add") || email === "contact@xpansecafe.com") && (
                            <Col lg="3" className="d-flex justify-content-end flex-column  mt-4">
                                <Button
                                variant="primary"
                                className="fw-semibold"
                                onClick={handleOpenAddModal}
                                >
                                    <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                    Add New Advertisement
                                </Button>
                            </Col>
                        )}
                    </Row>

                    <Row style={{ backgroundColor: "whitesmoke" }}>
                        {/* <Col> */}
                            <Container className="my-4">
                                <Tabs
                                    activeKey={activeTab}
                                    onSelect={handleTabChange}
                                    className="mb-4"
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '8px',
                                        padding: '10px',
                                        // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <Tab
                                        eventKey="CLICKABLE"
                                        title="CLICKABLE"
                                        style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
                                    >
                                        <Row className="mt-3 g-3">
                                            {listLoading ? (
                                                // Skeleton Loading for Clickable Ads
                                                Array.from({ length: 4 }).map((_, index) => (
                                                    <Col key={`skeleton-clickable-${index}`} lg={3} md={4}>
                                                        <Card
                                                            className="h-100 skeleton-card"
                                                            style={{
                                                                border: '1px solid #e9ecef',
                                                                borderRadius: '10px',
                                                            }}
                                                        >
                                                            <Card.Body className="text-center" style={{ padding: '20px' }}>
                                                                {/* Skeleton for Image */}
                                                                <div
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '200px',
                                                                        borderRadius: '8px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        marginBottom: '15px'
                                                                    }}
                                                                />
                                                                {/* Skeleton for Title */}
                                                                <div
                                                                    style={{
                                                                        width: '80%',
                                                                        height: '20px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        borderRadius: '4px',
                                                                        margin: '0 auto'
                                                                    }}
                                                                />
                                                            </Card.Body>
                                                            {/* Skeleton for Action Buttons */}
                                                            <div
                                                                className="d-flex justify-content-around p-2"
                                                                style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
                                                            >
                                                                {[1, 2, 3].map((btnIndex) => (
                                                                    <div
                                                                        key={btnIndex}
                                                                        style={{
                                                                            width: '60px',
                                                                            height: '32px',
                                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                            backgroundSize: '200% 100%',
                                                                            animation: 'skeletonPulse 1.5s infinite',
                                                                            borderRadius: '4px',
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                ))
                                            ) : clickableAdvertisementData.length === 0 ? (
                                                // Empty State
                                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
                                                    <div className="text-center">
                                                        <div className="text-muted mb-2">
                                                            <i className="bi bi-megaphone" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
                                                        </div>
                                                        <p className="text-muted">No clickable advertisements found</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                // Actual Clickable Ads
                                                clickableAdvertisementData.map((ad) => (
                                                    <Col key={ad.id} lg={3} md={4}>
                                                        <Card
                                                            className="h-100"
                                                            style={{
                                                                border: '1px solid #e9ecef',
                                                                borderRadius: '10px',
                                                                transition: 'transform 0.2s, box-shadow 0.2s',
                                                                cursor: 'pointer',
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                        >
                                                            <Card.Body className="text-center" style={{ padding: '20px' }}>
                                                                <Image
                                                                    src={ad.adImagePath}
                                                                    onClick={() => openUpdateImageModal(ad)}
                                                                    alt="ad-pic"
                                                                    fluid
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        maxHeight: '200px',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                                <h5
                                                                    className="mt-3"
                                                                    style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
                                                                >
                                                                    {ad.title.toUpperCase()}
                                                                </h5>
                                                            </Card.Body>
                                                            <div
                                                                className="d-flex justify-content-around p-2"
                                                                style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
                                                            >
                                                                {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="light"
                                                                        title="View"
                                                                        className='text-success'
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                        onClick={() => handleOpenViewModal(ad._id)}
                                                                    >
                                                                        <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
                                                                    </Button>
                                                                )}
                                                                {(addAccess?.includes("AdvertisementMgt:udpate") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        className='text-primary'
                                                                        variant="light"
                                                                        title="Edit"
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                        onClick={() => handleOpenEditModal(ad)}
                                                                    >
                                                                        <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
                                                                    </Button>
                                                                )}
                                                                {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        className='text-danger'
                                                                        variant="light"
                                                                        title="Delete"
                                                                        onClick={() => handleOpenDeleteModal(ad._id)}
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                        
                                                                    >
                                                                        <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                ))
                                            )}
                                        </Row>
                                    </Tab>

                                    <Tab
                                        eventKey="NON CLICKABLE"
                                        title="NON CLICKABLE"
                                        style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
                                    >
                                        <Row className="mt-3 g-3">
                                            {listLoading ? (
                                                // Skeleton Loading for Non-Clickable Ads
                                                Array.from({ length: 4 }).map((_, index) => (
                                                    <Col key={`skeleton-nonclickable-${index}`} lg={3} md={4}>
                                                        <Card
                                                            className="h-100 skeleton-card"
                                                            style={{
                                                                border: '1px solid #e9ecef',
                                                                borderRadius: '10px',
                                                            }}
                                                        >
                                                            <Card.Body className="text-center" style={{ padding: '20px' }}>
                                                                {/* Skeleton for Image */}
                                                                <div
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '200px',
                                                                        borderRadius: '8px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        marginBottom: '15px'
                                                                    }}
                                                                />
                                                                {/* Skeleton for Title */}
                                                                <div
                                                                    style={{
                                                                        width: '80%',
                                                                        height: '20px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        borderRadius: '4px',
                                                                        margin: '0 auto'
                                                                    }}
                                                                />
                                                            </Card.Body>
                                                            {/* Skeleton for Action Buttons */}
                                                            <div
                                                                className="d-flex justify-content-around p-2"
                                                                style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
                                                            >
                                                                {[1, 2, 3].map((btnIndex) => (
                                                                    <div
                                                                        key={btnIndex}
                                                                        style={{
                                                                            width: '60px',
                                                                            height: '32px',
                                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                            backgroundSize: '200% 100%',
                                                                            animation: 'skeletonPulse 1.5s infinite',
                                                                            borderRadius: '4px',
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                ))
                                            ) : nonClickableAdvertisementData.length === 0 ? (
                                                // Empty State
                                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
                                                    <div className="text-center">
                                                        <div className="text-muted mb-2">
                                                            <i className="bi bi-image" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
                                                        </div>
                                                        <p className="text-muted">No non-clickable advertisements found</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                // Actual Non-Clickable Ads
                                                nonClickableAdvertisementData.map((ad) => (
                                                    <Col key={ad.id} lg={3} md={4}>
                                                        <Card
                                                            className="h-100"
                                                            style={{
                                                                border: '1px solid #e9ecef',
                                                                borderRadius: '10px',
                                                                transition: 'transform 0.2s, box-shadow 0.2s',
                                                                cursor: 'pointer',
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                        >
                                                            <Card.Body className="text-center" style={{ padding: '20px' }}>
                                                                <Image
                                                                    src={ad.adImagePath}
                                                                    onClick={() => openUpdateImageModal(ad)}
                                                                    alt="ad-pic"
                                                                    fluid
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        maxHeight: '200px',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                                <h5
                                                                    className="mt-3"
                                                                    style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
                                                                >
                                                                    {ad.title.toUpperCase()}
                                                                </h5>
                                                            </Card.Body>
                                                            <div
                                                                className="d-flex justify-content-around p-2"
                                                                style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
                                                            >
                                                                {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="light"
                                                                        title="View"
                                                                        size='sm'
                                                                        className='text-success'
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                        onClick={() => handleOpenViewModal(ad._id)}
                                                                    >
                                                                        <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
                                                                    </Button>
                                                                )}
                                                                {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="light"
                                                                        title="Edit"
                                                                        size='sm'
                                                                        className='text-primary'
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                        onClick={() => handleOpenEditModal(ad)}
                                                                    >
                                                                        <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
                                                                    </Button>
                                                                )}
                                                                {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="light"
                                                                        title="Delete"
                                                                        size='sm'
                                                                        className='text-danger'
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                        onClick={() => handleOpenDeleteModal(ad._id)}
                                                                    >
                                                                        <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                ))
                                            )}
                                        </Row>
                                    </Tab>

                                    <Tab
                                        eventKey="TOP & BOTTOM IMAGES"
                                        title="TOP & BOTTOM IMAGES"
                                        style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
                                    >
                                        <Row className="mt-3 g-3">
                                            {listLoading ? (
                                                // Skeleton Loading for Top & Bottom Images
                                                Array.from({ length: 4 }).map((_, index) => (
                                                    <Col key={`skeleton-topbottom-${index}`} lg={3} md={4}>
                                                        <Card
                                                            className="h-100 skeleton-card"
                                                            style={{
                                                                border: '1px solid #e9ecef',
                                                                borderRadius: '10px',
                                                            }}
                                                        >
                                                            <Card.Body className="text-center" style={{ padding: '20px' }}>
                                                                {/* Skeleton for Image */}
                                                                <div
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '200px',
                                                                        borderRadius: '8px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        marginBottom: '15px'
                                                                    }}
                                                                />
                                                                {/* Skeleton for Title */}
                                                                <div
                                                                    style={{
                                                                        width: '80%',
                                                                        height: '20px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        borderRadius: '4px',
                                                                        margin: '0 auto'
                                                                    }}
                                                                />
                                                            </Card.Body>
                                                            {/* Skeleton for Action Buttons */}
                                                            <div
                                                                className="d-flex justify-content-around p-2"
                                                                style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
                                                            >
                                                                {[1, 2].map((btnIndex) => (
                                                                    <div
                                                                        key={btnIndex}
                                                                        style={{
                                                                            width: '60px',
                                                                            height: '32px',
                                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                            backgroundSize: '200% 100%',
                                                                            animation: 'skeletonPulse 1.5s infinite',
                                                                            borderRadius: '4px',
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                ))
                                            ) : topImageAdd.length === 0 && !bottomImageAdd ? (
                                                // Empty State
                                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
                                                    <div className="text-center">
                                                        <div className="text-muted mb-2">
                                                            <i className="bi bi-layout-three-columns" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
                                                        </div>
                                                        <p className="text-muted">No top or bottom images found</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                // Actual Top & Bottom Images
                                                <>
                                                    {topImageAdd.map((ad) => (
                                                        <Col key={ad.id} lg={3} md={4}>
                                                            <Card
                                                                className="h-100"
                                                                style={{
                                                                    border: '1px solid #e9ecef',
                                                                    borderRadius: '10px',
                                                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Card.Body className="text-center" style={{ padding: '20px' }}>
                                                                    <Image
                                                                        onClick={() => openUpdateImageModal(ad)}
                                                                        src={ad.adImagePath}
                                                                        alt="ad-pic"
                                                                        fluid
                                                                        style={{
                                                                            borderRadius: '8px',
                                                                            maxHeight: '200px',
                                                                            objectFit: 'cover',
                                                                        }}
                                                                    />
                                                                    <h5
                                                                        className="mt-3"
                                                                        style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
                                                                    >
                                                                        {ad.title.toUpperCase()}
                                                                    </h5>
                                                                </Card.Body>
                                                                <div
                                                                    className="d-flex justify-content-around p-2"
                                                                    style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
                                                                >
                                                                    {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
                                                                        <Button
                                                                            variant="light"
                                                                            title="View"
                                                                            size='sm'
                                                                            className='text-success'
                                                                            style={{ padding: '8px', margin: '0 5px' }}
                                                                            onClick={() => handleOpenViewModal(ad._id)}
                                                                        >
                                                                            <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
                                                                        </Button>
                                                                    )}
                                                                    {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
                                                                        <Button
                                                                            variant="light"
                                                                            title="Edit"
                                                                            size='sm'
                                                                            className='text-primary'
                                                                            style={{ padding: '8px', margin: '0 5px' }}
                                                                            onClick={() => handleOpenEditModal(ad)}
                                                                        >
                                                                            <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
                                                                        </Button>
                                                                    )}
                                                                    {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
                                                                        <Button
                                                                            variant="light"
                                                                            title="Delete"
                                                                            className='text-danger'
                                                                            onClick={() => handleOpenDeleteModal(ad._id)}
                                                                            style={{ padding: '8px', margin: '0 5px' }}
                                                                        >
                                                                            <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                    <Col lg={3} md={4}>
                                                        <Card
                                                            className="h-100"
                                                            style={{
                                                                border: '1px solid #e9ecef',
                                                                borderRadius: '10px',
                                                                transition: 'transform 0.2s, box-shadow 0.2s',
                                                                cursor: 'pointer',
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                        >
                                                            <Card.Body className="text-center" style={{ padding: '20px' }}>
                                                                <Image
                                                                    onClick={() => openUpdateImageModal(bottomImageAdd)}
                                                                    src={bottomImageAdd?.adImagePath}
                                                                    alt="ad-pic"
                                                                    fluid
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        maxHeight: '200px',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                                <h5
                                                                    className="mt-3"
                                                                    style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
                                                                >
                                                                    {bottomImageAdd?.title?.toUpperCase()}
                                                                </h5>
                                                            </Card.Body>
                                                            <div
                                                                className="d-flex justify-content-around p-2"
                                                                style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
                                                            >
                                                                {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="light"
                                                                        title="Edit"
                                                                        size='sm'
                                                                        className='text-primary'
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                        onClick={() => handleOpenEditModal(bottomImageAdd)}
                                                                    >
                                                                        <i className="bi bi-pencil" style={{ fontSize: '18px' }}></i> Edit
                                                                    </Button>
                                                                )}
                                                                {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="light"
                                                                        title="Delete"
                                                                        className='text-danger'
                                                                        onClick={() => handleOpenDeleteModal(bottomImageAdd?._id)}
                                                                        size='sm'
                                                                        style={{ padding: '8px', margin: '0 5px' }}
                                                                    >
                                                                        <i className="bi bi-trash" style={{ fontSize: '18px' }}></i> Delete
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                </>
                                            )}
                                        </Row>
                                    </Tab>
                                </Tabs>

                            </Container>
                        {/* </Col> */}
                    </Row>

                    {openAddModal ? (
                        <Modal show={openAddModal} onHide={handleCloseAddModal} centered size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title className="fs-6 fw-semibold pt-1">
                                    ADD ADVERTISEMENT
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={addAdvertisement}>
                                <Modal.Body>
                                    <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Title <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Title"
                                            name="title"
                                            value={inputData.title}
                                            onChange={handleInputChange}
                                        />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Select Type <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            size="sm"
                                            onChange={handleInputChange}
                                            value={inputData?.type}
                                            name="type"
                                        >
                                            <option value="">Select Type</option>
                                            <option value="CLICKABLE">CLICKABLE</option>
                                            <option value="NON-CLICKABLE">NON-CLICKABLE</option>
                                        </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    </Row>
                        
                                    <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Sequence No. <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Sequence No."
                                            name="sequenceNo"
                                            value={inputData?.sequenceNo}
                                            onChange={handleInputChange}
                                        />
                                        </Form.Group>
                                    </Col>
                                    {inputData?.type === "NON-CLICKABLE" ? (
                                        <>
                                        <Col>
                                            <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Top Image</Form.Label>
                                            <Form.Select
                                                size="sm"
                                                onChange={handleInputChange}
                                                name="isTopImage"
                                                value={inputData?.isTopImage}
                                            >
                                                <option value="" disabled>Is it Top Image</option>
                                                <option value="true">YES</option>
                                                <option value="false">NO</option>
                                            </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Bottom Image</Form.Label>
                                            <Form.Select
                                                size="sm"
                                                onChange={handleInputChange}
                                                name="isBottomImage"
                                                value={inputData?.isBottomImage}
                                            >
                                                <option value="" disabled>Is It Bottom Image</option>
                                                <option value="true">YES</option>
                                                <option value="false">NO</option>
                                            </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        </>
                                    ) : (
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Select Product <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                            options={productsList.map((rm) => ({
                                                value: rm._id,
                                                label: rm.name,
                                            }))}
                                            value={
                                                inputData?.product
                                                ? productsList
                                                    .map((rm) => ({ value: rm._id, label: rm.name }))
                                                    .find((option) => option.value === inputData.product)
                                                : null
                                            }
                                            onChange={(selectedOption) => {
                                                if (selectedOption) {
                                                handleInputChange({ target: { name: 'product', value: selectedOption.value } });
                                                } else {
                                                handleInputChange({ target: { name: 'product', value: '' } });
                                                }
                                            }}
                                            classNamePrefix="react-select"
                                            isClearable
                                            placeholder="Select Product"
                                            />
                                        </Form.Group>
                                        </Col>
                                    )}
                                    </Row>
                        
                                    <Row className="mb-2">
                                    <Col md="3">
                                        <Form.Group>
                                        <Form.Label className="fw-semibold">Validity Start Date</Form.Label>
                                        <DatePicker
                                            selected={fromDate}
                                            onChange={handleFromDateChange}
                                            placeholderText="Start Date"
                                            className="form-control"
                                            isClearable
                                        />
                                        </Form.Group>
                                    </Col>
                                    <Col md="3">
                                        <Form.Group>
                                        <Form.Label className="fw-semibold">Validity End Date</Form.Label>
                                        <DatePicker
                                            selected={toDate}
                                            onChange={handleToDateChange}
                                            placeholderText="End Date"
                                            className="form-control"
                                            isClearable
                                        />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6">
                                        <Form.Group>
                                        <Form.Label className="fw-semibold">Select Excluded Outlets</Form.Label>
                                        <Select
                                            isMulti
                                            value={selectedExcludedOutlets}
                                            onChange={handleSelectChange}
                                            options={outletData}
                                            placeholder="Select Excluded Outlets"
                                            closeMenuOnSelect={false}
                                        />
                                        </Form.Group>
                                    </Col>
                                    </Row>
                        
                                    <Row>
                                    <Col md="6">
                                        <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">Add Link</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Add Link"
                                            name="link"
                                            value={inputData.link}
                                            disabled={inputData.type === "CLICKABLE"}
                                            onChange={handleInputChange}
                                        />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6">
                                        <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Choose File <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleImageChange}
                                            id="imageInput"
                                        />
                                        <p className="text-danger" style={{ fontSize: '13px' }}>Choose an image with 1920x1080 pixels</p>
                                        </Form.Group>
                                    </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" type="submit" disabled={isLoading}>
                                    {isLoading ? <Spinner size='sm' /> : 'ADD ADVERTISEMENT'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {openEditModal ? (
                        <Modal
                            show={openEditModal}
                            onHide={() => setOpenEditModal(false)}
                            centered
                            size="lg"
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="VerticallyCenteredExample" className="fs-6">
                                    EDIT ADVERTISEMENT
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body>
                                    {/* Title, Type, and Sequence Number */}
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Title"
                                                    name="title"
                                                    value={editedData?.title || ""}
                                                    onChange={handleEditChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Select Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    onChange={handleEditChange}
                                                    value={editedData?.type || ""}
                                                    name="type"
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="CLICKABLE">CLICKABLE</option>
                                                    <option value="NON-CLICKABLE">NON-CLICKABLE</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Sequence No. <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Sequence No."
                                                    name="sequenceNo"
                                                    value={editedData?.sequenceNo || ""}
                                                    onChange={handleEditChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* Validity Start and End Date */}
                                    <Row className="mb-2">
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="fw-semibold">
                                                    Validity Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={fromDate}
                                                    onChange={handleFromDateChange}
                                                    placeholderText="Start Date"
                                                    className="form-control"
                                                    isClearable
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="fw-semibold">
                                                    Validity End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={toDate}
                                                    onChange={handleToDateChange}
                                                    placeholderText="End Date"
                                                    className="form-control"
                                                    isClearable
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* Conditional Rendering for Link, Top Image, and Bottom Image */}
                                    <Row>
                                        {editedData?.isTopImage || editedData?.isBottomImage ? (
                                            <>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label className="fw-semibold">Add Link</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Add Link"
                                                            name="link"
                                                            value={editedData?.link || ""}
                                                            disabled={editedData?.type === "NON-CLICKABLE"}
                                                            onChange={handleEditChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Top Image <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            onChange={handleEditChange}
                                                            name="isTopImage"
                                                            value={editedData?.isTopImage || ""}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="true">YES</option>
                                                            <option value="false">NO</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Bottom Image <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            onChange={handleEditChange}
                                                            name="isBottomImage"
                                                            value={editedData?.isBottomImage || ""}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="true">YES</option>
                                                            <option value="false">NO</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        ) : (
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Select Product <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={productsList.map((rm) => ({
                                                            value: rm._id,
                                                            label: rm.name,
                                                        }))}
                                                        value={
                                                            editedData?.product
                                                                ? productsList
                                                                    .map((rm) => ({ value: rm._id, label: rm.name }))
                                                                    .find((option) => option.value === editedData?.product)
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            handleEditChange({
                                                                target: {
                                                                    name: 'product',
                                                                    value: selectedOption ? selectedOption.value : "",
                                                                },
                                                            });
                                                        }}
                                                        classNamePrefix="react-select"
                                                        isDisabled={editedData?.type === "NON-CLICKABLE"}
                                                        isClearable
                                                        placeholder="Select Product"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>

                                    {/* Excluded Outlets */}
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="fw-semibold">
                                                    Select Excluded Outlets
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    value={selectedExcludedOutlets}
                                                    onChange={handleEditSelectChange}
                                                    options={outletData}
                                                    styles={customStyles}
                                                    placeholder="Select Excluded Outlets"
                                                    closeMenuOnSelect={false}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Modal.Body>

                                {/* Footer with Save Button */}
                                <Modal.Footer>
                                    <Button variant="primary" type="submit" disabled={isLoading}>
                                        {isLoading ? <Spinner size="sm" /> : 'SAVE CHANGES'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {openViewModal ? (
                        <Modal
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            centered
                            size="lg"
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="VerticallyCenteredExample" className="fs-6">
                                    VIEW ADVERTISEMENT DETAILS
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    <h5 className="text-center">
                                        {singleAdData?.title && singleAdData.title.toUpperCase()}
                                    </h5>
                                </div>
                                <hr />
                                <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                                    {singleAdData?.validityStartDate && singleAdData?.validityEndDate ? (
                                        <>
                                            <span className="fw-semibold">
                                                Validity Starting From: 
                                                <span>
                                                    {new Date(singleAdData?.validityStartDate).toLocaleDateString('en-GB', {
                                                        year: 'numeric',
                                                        month: 'numeric',
                                                        day: 'numeric',
                                                    })}
                                                </span>
                                            </span>
                                            <span className="fw-semibold">
                                                Validity Ending On: 
                                                <span>
                                                    {new Date(singleAdData?.validityEndDate).toLocaleDateString('en-GB', {
                                                        year: 'numeric',
                                                        month: 'numeric',
                                                        day: 'numeric',
                                                        timeZone: 'UTC', // Force UTC timezone
                                                    })}
                                                </span>
                                            </span>
                                        </>
                                    ) : (
                                        <span className="fw-semibold text-success">NO VALIDITY FOR THIS ADVERTISEMENT</span>
                                    )}
                                </div>
                                <div className="d-flex justify-content-center">
                                    <img
                                        src={singleAdData?.adImagePath}
                                        alt="ad-photo"
                                        className="w-100"
                                    />
                                </div>
                                <div className="mt-2">
                                    <h6>
                                        Excluded Outlets:{" "}
                                        <span className="text-danger">
                                            {singleAdData?.excludedOutlets && singleAdData?.excludedOutlets?.length > 0
                                                ? singleAdData?.excludedOutlets?.map(outlet => outlet?.name?.toLowerCase().trim()).join(', ')
                                                : "No outlets excluded."}
                                        </span>
                                    </h6>
                                </div>
                                {activeTab === "CLICKABLE" ? (
                                    <div className="mt-3">
                                        <Table bordered>
                                            <thead>
                                                <tr>
                                                    <th className="text-center" colSpan={6}>
                                                        PRODUCT INFORMATION
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th className="text-center">IMAGE</th>
                                                    <th className="text-center">NAME</th>
                                                    <th className="text-center">DESCRIPTION</th>
                                                    <th className="text-center">HSN</th>
                                                    <th className="text-center">MRP</th>
                                                    <th className="text-center">OFFER PRICE</th>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">
                                                        <img
                                                            src={singleAdData?.product?.displayImage}
                                                            alt="product-image"
                                                            style={{ width: "100px", height: "100px" }}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        {singleAdData?.product?.name}
                                                    </td>
                                                    <td className="text-center">
                                                        {singleAdData?.product?.description}
                                                    </td>
                                                    <td className="text-center">
                                                        {singleAdData?.product?.hsn}
                                                    </td>
                                                    <td className="text-center">
                                                        {singleAdData?.product?.mrp}
                                                    </td>
                                                    <td className="text-center">
                                                        {singleAdData?.product?.offerPrice} Rs
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                ) : null}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="warning"
                                    onClick={() => setOpenViewModal(false)}
                                    style={{ borderRadius: "18px" }}
                                >
                                    CLOSE
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null}

                    {openDeleteModal && (
                        <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirm Delete</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this Advertisement? This action cannot be undone.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={deleteAdvertisement}>
                                    { isDeleteBtnLoading ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> :
                                        "Delete Advertisement"                                
                                    }
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                    {isOpenUpdateImageModal && (
                        <Modal
                            show={isOpenUpdateImageModal}
                            onHide={() => setIsOpenUpdateImageModal(false)}
                            centered
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="VerticallyCenteredExample" className="fs-6">
                                    UPDATE ADVERTISEMENT IMAGE
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditImage}>
                                <Modal.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Choose File <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleEditImageChange}
                                            id="imageInput"
                                        />
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" type='submit'>
                                        {isImageUpdating ? <Spinner size='sm' /> : 'SAVE CHANGES' }
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                </div>
            </div>
            {/* Add CSS Animation */}
            <style>
                {`
                    @keyframes skeletonPulse {
                        0% {
                            background-position: 200% 0;
                        }
                        100% {
                            background-position: -200% 0;
                        }
                    }
                    
                    .skeleton-card {
                        pointer-events: none;
                    }
                `}
            </style>
        </React.Fragment>
    )
}

export default AdvertisementMgt